// extracted by mini-css-extract-plugin
export default {"dialogBody":"DeleteAccount_dialogBody__7IEda","dialogBodyMultiParagraph":"DeleteAccount_dialogBodyMultiParagraph__HdkV6","dialogMultiButton":"DeleteAccount_dialogMultiButton__F12tG"};